export const formatFreshness = (date: Date): { label: string; tooltip: string } => {
  const diffMs = Date.now() - date.getTime()
  const diffMin = Math.floor(diffMs / 60000)
  const diffHours = Math.floor(diffMs / 3600000)
  const diffDays = Math.floor(diffMs / 86400000)

  const fullDate = new Intl.DateTimeFormat('en-IN', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date)

  let relative = 'just now'
  if (diffDays >= 7) {
    relative = fullDate
  } else if (diffDays >= 1) {
    relative = `${diffDays} d ago`
  } else if (diffHours >= 1) {
    relative = `${diffHours} h ago`
  } else if (diffMin >= 1) {
    relative = `${diffMin} m ago`
  }

  return {
    label: relative,
    tooltip: `${fullDate} (${relative})`,
  }
}
